// extracted by mini-css-extract-plugin
export default {"e_learning_results_wrapper":"ELearningResults_e_learning_results_wrapper__MJB8O"};